import React, { useEffect, useMemo} from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import * as Actions from "us.collection.economy/actions";
import { IconTypes, BoxIcons } from "us.icons";
import { IDashboard, IRecord } from "../../Interfaces";
import { AccountItem } from "./Components";
import { getExportData, sortAccounts } from "../../Functions";

import {
  $Button,
  $Skeleton,
  $AmountLabel,
  $Divider,
} from "us.common/components";

const Dashboard: React.FC<PropsFromRedux & IDashboard> = (props) => {
  const { t } = useTranslation();

  const {
    journalId,
    accountsDetails,
    isDetailsLoading,
    currentCurrency,
    currentLanguage,
    getLedgerDetails,
    onClose,
  } = props;

  const { accounts } = accountsDetails ?? {};
  const sortedAccounts = useMemo(() => sortAccounts(accounts ?? []), [accounts]);

  useEffect(() => {
    getLedgerDetails && getLedgerDetails({ journalId });
  }, []);

  return (
    <>
      <$Skeleton loading={isDetailsLoading} active paragraph={{ rows: 3 }}>
        <div>
          <div className="page-header header-border">
            <div className="d-flex justify-content-end pb-2 pr-4">
              <div>
                <div data-testid="csv-link" className="mr-1">
                  <$Button
                    type="default"
                    size="small"
                    icon={
                      <BoxIcons
                        className="mr-1"
                        type={IconTypes.BOX_ICON}
                        name="excel"
                      />
                    }
                  >
                    <CSVLink
                      separator={currentCurrency == "NOK" ? ";" : ","}
                      filename={`${journalId}.csv`}
                      data={getExportData(
                        accounts,
                        currentLanguage,
                        currentCurrency
                      )}
                    >
                      {t(
                        "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.EXPORT_TO_EXCEL"
                      )}
                    </CSVLink>
                  </$Button>
                </div>
              </div>
            </div>
          </div>
          <div className="cardledger-wrap-outer">
            {sortedAccounts.map((record: IRecord) => (
              <AccountItem record={record} key={record.accountId} />
            ))}
          </div>
        </div>
      </$Skeleton>
      <div className="drawer-footer-fixed d-flex align-items-center justify-content-between">     
        <span>
          <small>
            {t(
              "US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.OPENING_AND_CLOSING_BALANCES"
            )}
          </small>
        </span>
        <div>
          <$Button onClick={onClose} data-testid="cancel-dashboard">
            {t("US.COLLECTION.COMMON:COMMON.CANCEL")}
          </$Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  const { common, remitHistory } = state;
  const { currentDateFormat, currentLanguage, currentCurrency } = common;
  const { accountsDetails, isDetailsLoading } = remitHistory;

  return {
    currentDateFormat,
    currentLanguage,
    currentCurrency,
    accountsDetails,
    isDetailsLoading,
  };
};

const { ledgerDetails } = Actions.remitHistory;

const mapDispatchToProps = {
  getLedgerDetails: ledgerDetails.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Dashboard);
